import { requireNativeComponent } from 'react-native';

/**
 * Getting camera share view from native layer.
 */
export const CameraView = requireNativeComponent('RNZoomCameraShareView');
